import React from 'react';
import { graphql } from 'gatsby';
import { Layout, SliceZone } from '../components';
import {
  useMousePosition,
  useDimensions,
  useScrollPosition,
} from '../util/hooks';
import { isClient } from '../util/helpers';
import './general-template.scss';

const GeneralTemplate = (props) => {
  const {
    data: {
      page: {
        data: pageData,
      },
    },
    location,
  } = props;
  const {
    metaTitle,
    metaDescription,
    openGraphImage,
    body,
  } = pageData;
  const seoData = {
    metaTitle,
    metaDescription,
    openGraphImage,
  };
  const {
    x: cursorX,
    y: cursorY,
  } = useMousePosition();
  const {
    viewportWidth,
    viewportHeight,
    documentHeight,
  } = useDimensions();
  const viewportTopPos = useScrollPosition();
  if (isClient) document.documentElement.style.setProperty('--bg-colour', '#FFFFF4');
  return (
    <Layout
      location={location}
      seoData={seoData}
      cursorX={cursorX}
      cursorY={cursorY}
      viewportWidth={viewportWidth}
      viewportHeight={viewportHeight}
      documentHeight={documentHeight}
      viewportTopPos={viewportTopPos}
    >
      <div className="general-page-body">
        <SliceZone
          allSlices={body}
          location={location}
        />
      </div>
    </Layout>
  );
};

export default GeneralTemplate;

export const pageQuery = graphql`
  query GeneralTemplateQuery($uid: String!) {
    page: prismicGeneralTemplate(uid: { eq: $uid }) {
      uid,
      data {
        metaTitle: meta_title {
          html
          text
        },
        metaDescription: meta_description {
          html
          text
        },
        openGraphImage: open_graph_image {
          alt
          copyright
          url
        }
        body {
          ... on PrismicGeneralTemplateBodyEnquiryFormBlock {
            id
            sliceType: slice_type
            primary {
              formTitle: form_title {
                text
              }
              formDescription: form_description {
                html
              }
            }
          }
        }
      }
    }
  }
`;
